import { Routes, Route } from 'react-router-dom'
import PoolsListPage from './PoolsListPage'
import PoolDetailRouter from './PoolDetailRouter'

export default function PoolsPage() {
  return (
    <Routes>
      <Route path="/" element={<PoolsListPage />} />
      <Route path="/:poolId" element={<PoolDetailRouter />} />
    </Routes>
  )
}